import updateQueryExercisesAction from '../update-query'
import getQueryExercisesSelect from '../../selectors/get-query'

function updateFiltersExercisesAction () {
  return (dispatch, getState) => {
    // Update the query to find the exercises
    // based on the updated filters
    const query = getQueryExercisesSelect(getState())
    dispatch(updateQueryExercisesAction(query))
  }
}

export default updateFiltersExercisesAction
